export enum VendorQuoteLogColId {
  ANOMALIES = 'anomalies',
  COMPANY = 'company',
  CUSTOMER_QUOTE_IDS = 'customerQuoteIds',
  DELIVERED_VIA = 'deliveredVia',
  DISCOUNT_COUNT = 'discountCount',
  DOCUMENT_ID = 'documentId',
  DURATION = 'duration',
  ERROR = 'error',
  FILE_NAME = 'fileName',
  IMPORT_ID = 'importId',
  IMPORTED_MANUFACTURER = 'importedManufacturer',
  IMPORTED_PART_COUNT = 'importedPartCount',
  OUTCOME = 'outcome',
  PART_COUNT = 'partCount',
  PARTFINITI_MANUFACTURER = 'partfinitiManufacturer',
  POLL_COUNT = 'pollCount',
  STARTED_AT = 'startedAt',
  USER = 'user',
  VENDOR_QUOTE_ID = 'quoteId',
}
